import React from "react";
import { modal } from "../modal";
import { openContact } from "../../common/callUtil"

export const modal_type_contact_other = props => {
  const { asset, room, eventTrackingId } = props;
  return (
    <div className="modal_type_contact_other modal_base">
      <div className="cross" onClick={() => modal.closeModal()} />
      <div className="title">
        <span>上記以外のお問い合わせ</span>
      </div>
      <div className="collection">
        <a
          className="item link"
          href="/hello-storage/contact/?customer_kbn=2"
          target="_blank"
        >
          <div>ビジネスのご相談
            <div className="subtext">（土地活用やパートナー提携）</div>
          </div>
        </a>
        <a
          className="item link"
          href=""
          onClick={e => {
            e.preventDefault();
            openContact("related_complaint", {
              asset,
              room,
              eventTrackingId,
            });
          }}
        >
          <div>物件に関する苦情</div>
        </a>
        <a
          className="item link"
          href=""
          onClick={e => {
            e.preventDefault();
            openContact("related_etc", {
              asset,
              room,
              eventTrackingId,
            });
          }}
        >
          <div>その他、ご意見</div>
        </a>
      </div>
      <p className="collection_paragraph">
        <a onClick={e => {
          e.preventDefault();
          modal.back();
        }}>
          <img src="resource/img/s_arrow_left.png" />前の画面に戻る
        </a>
      </p>
    </div>
  );
};



// WEBPACK FOOTER //
// ./common/modal/modal_type_contact_other.jsx